import { z } from "zod";
import { randomThemeSlug } from "@scalar-org/random-slug";
import { nanoid, nanoidSchema, slugSchema } from "../utility/index.js";
const themeSchema = z.object({
  uid: nanoidSchema,
  name: z.string(),
  description: z.string(),
  theme: z.string(),
  slug: slugSchema
}).meta({ id: "theme" });
const defaultTheme = (cssString = "") => ({
  uid: nanoid(),
  name: "Default Theme",
  slug: randomThemeSlug(),
  description: "",
  theme: cssString
});
export {
  defaultTheme,
  themeSchema
};
//# sourceMappingURL=index.js.map
